import type { CelestialBody } from '../types'

// The three dwarfs: outposts at the edge, mostly forgotten.
export const othrys: CelestialBody = {
  id: 'othrys',
  name: 'Othrys',
  type: 'dwarf',
  tagline: 'The largest dwarf, and the one with the most intact outpost.',
  lore: `The largest of the dwarfs, and the one with the most intact outpost. People forget it's here; the people on it prefer that.`,
  render: { color: '#9a8a7a', size: 4, orbitRadius: 660, orbitPeriod: 230, phase: 0.2 },
}

export const vrix: CelestialBody = {
  id: 'vrix',
  name: 'Vrix',
  type: 'dwarf',
  tagline: 'Cold, quiet, half-mined-out.',
  lore: `Cold, quiet, half-mined-out. The outpost is more a shelter than a settlement.`,
  render: { color: '#8a7e72', size: 3.6, orbitRadius: 690, orbitPeriod: 245, phase: 2.0 },
}

export const nemora: CelestialBody = {
  id: 'nemora',
  name: 'Nemora',
  type: 'dwarf',
  tagline: 'The outermost body anyone bothers to name.',
  lore: `The outermost body anyone bothers to name. A few souls live here on purpose. No one asks why.`,
  render: { color: '#7e9a8a', size: 3.8, orbitRadius: 725, orbitPeriod: 260, phase: 4.2 },
}

// One shared lorebook entry for all three. The individuals above stay in the
// lore model so the map can orbit them as separate nodes; this entry is what
// the lorebook shows. Its sections reuse each dwarf's id so deep links like
// /lorebook/dwarfs#othrys land on the right section.
export const dwarfPlanets: CelestialBody = {
  id: 'dwarfs',
  name: 'Dwarf Planets',
  type: 'dwarf',
  tagline: 'The three forgotten worlds at the edge of the system.',
  lore: `Beyond the mapped planets, three dwarf worlds drift at the outer edge of the system. They are barely inhabited and barely useful, more waypoint than destination, but a few souls live on each of them for reasons of their own. 
  
  These dwarfs are not used for anything yet. If you have suggestions for what they could be in the lore, please just suggest the ideas to in the jam thread. We can write entries as we go. 
  `,
  sections: [
    { id: othrys.id, title: othrys.name, body: othrys.lore },
    { id: vrix.id, title: vrix.name, body: vrix.lore },
    { id: nemora.id, title: nemora.name, body: nemora.lore },
  ],
  // not rendered on the map (only the individuals are); placeholder required by the type.
  render: { color: '#8a8478', size: 4, orbitRadius: 700, orbitPeriod: 250, phase: 0 },
}
